import { createApp } from 'vue'
import App from './App.vue'
import './css/styles.css'

createApp(App).mount('#app')
